
<script>
import TheNavigation from './the-navigation'
import TheErro from '@/components/sweet-erro'
import { mapState } from 'vuex'

export default {
  name: 'TheContainer',
  components: {
    TheNavigation,
    TheErro
  },
  computed: {
    ...mapState(['loading'])
  }
}
</script>

<template>
  <div id="app">

    <div class="progress loading-geral" v-show="loading">
      <div class="indeterminate green"></div>
    </div>
    
    <the-navigation></the-navigation>

    <the-erro></the-erro>

    <transition name="vux-pop-out">
      <router-view></router-view>
    </transition>

  </div>
</template>

<style lang="sass" src="./assets/sass/app.scss"></style>



// WEBPACK FOOTER //
// src/the-container.vue